import React from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber, FormattedRelativeTime, FormattedTime } from 'react-intl';
import { Row, Col } from 'reactstrap';
import classNames from 'classnames';
import SchemaTriggerIntervalValueType from '../../../../data/SchemaTriggerIntervalValueType';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function AssetServiceSchemaRow(props) {
    var onRemove = props.onRemove, serviceAssetSchemaModel = props.serviceAssetSchemaModel, serviceSchemaCollection = props.serviceSchemaCollection;
    var schemaModel = serviceSchemaCollection.findById(serviceAssetSchemaModel.schemaId);
    if (!schemaModel) {
        return null;
    }
    var classes = classNames({ 'asset-service-schema-row d-flex flex-wrap border-bottom px-0 py-3 w-100': true }) + ' ' + props.className;
    return React.createElement("div", { className: classes },
        React.createElement(Row, { className: "row w-100" },
            React.createElement(Col, { sm: 12 }, schemaModel.name)),
        React.createElement(Row, { className: "row w-100" },
            React.createElement(Col, { sm: 12, className: "text-muted" }, schemaModel.description)),
        React.createElement(Row, { className: "w-100 px-2" },
            React.createElement("div", { className: "list-group list-group-flush list-group-activity" },
                React.createElement("div", { className: "list-group-item" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-auto" },
                            React.createElement("div", { className: "avatar avatar-sm" },
                                React.createElement("div", { className: "avatar-title font-size-lg bg-white border rounded-circle text-primary" },
                                    React.createElement("i", { className: "fe fe-calendar" })))),
                        React.createElement("div", { className: "col ml-n2" },
                            React.createElement("h5", { className: "mb-1" },
                                React.createElement(FormattedMessage, { id: "page.service.entries.last", defaultMessage: "Vorige melding gesloten op:" })),
                            React.createElement("div", { className: "small text-gray-700 mb-0" }, serviceAssetSchemaModel.lastCloseDateTimeUtc ?
                                React.createElement("div", null,
                                    React.createElement(FormattedDate, { value: serviceAssetSchemaModel.lastCloseDateTimeUtc }),
                                    "\u00A0",
                                    React.createElement(FormattedTime, { value: serviceAssetSchemaModel.lastCloseDateTimeUtc }),
                                    React.createElement("br", null),
                                    React.createElement(FormattedRelativeTime, { value: (serviceAssetSchemaModel.lastCloseDateTimeUtc.getTime() - Date.now()) / 1000, updateIntervalInSeconds: 60 })) :
                                React.createElement("div", null, "-"))))),
                React.createElement("div", { className: "list-group-item" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-auto" },
                            React.createElement("div", { className: "avatar avatar-sm" },
                                React.createElement("div", { className: "avatar-title font-size-lg bg-white border rounded-circle text-primary" },
                                    React.createElement("i", { className: "fe fe-chevrons-down" })))),
                        React.createElement("div", { className: "col ml-n2" },
                            React.createElement("h5", { className: "mb-1" },
                                React.createElement(FormattedMessage, { id: "page.service.entries.next", defaultMessage: "Volgende melding" })),
                            React.createElement("p", { className: "small text-gray-700 mb-0" }, SchemaTriggerIntervalValueType.isPeriodial(schemaModel.triggerIntervalValueType) ?
                                React.createElement("div", null,
                                    React.createElement(FormattedDate, { value: new Date(serviceAssetSchemaModel.nextTriggerAssetValue) }),
                                    "\u00A0",
                                    React.createElement(FormattedTime, { value: new Date(serviceAssetSchemaModel.nextTriggerAssetValue) }),
                                    React.createElement("br", null),
                                    React.createElement(FormattedRelativeTime, { value: (new Date(serviceAssetSchemaModel.nextTriggerAssetValue).getTime() - Date.now()) / 1000, updateIntervalInSeconds: 60 })) :
                                React.createElement("div", null,
                                    React.createElement(FormattedNumber, { value: serviceAssetSchemaModel.nextTriggerAssetValue, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 })))))))),
        React.createElement(Row, { className: "justify-content-end w-100" },
            React.createElement("button", { className: "btn btn-sm btn-outline-danger", onClick: function () { return onRemove(serviceAssetSchemaModel); } },
                React.createElement("i", { className: "fe fe-trash" }),
                " ",
                React.createElement(FormattedMessage, { id: "asset.schema.remove" }))));
}
AssetServiceSchemaRow.defaultProps = {
    className: ''
};
